import styled, { css } from 'styled-components';

import { ColorPalette, MEDIA_QUERY, SPACING } from '@optimus-web/local-tokens';

import { GridItemProps, GridProps } from './types';

export const Grid = styled.div<GridProps>`
    display: grid;
    grid-auto-flow: ${(props) => props.autoFlow || 'auto'};
    grid-auto-columns: ${(props) => props.autoColumns || 'auto'};
    grid-auto-rows: ${(props) => props.autoRows || 'auto'};
    grid-template-areas: ${(props) => props.templateAreas || 'auto'};
    grid-template-columns: ${(props) => props.templateColumns || 'auto'};
    grid-template-rows: ${(props) => props.templateRows || 'auto'};
    height: ${(props) => props.height || 'auto'};
    ${(props) => props.alignItems && `align-items: ${props.alignItems}`};

    ${(props) =>
        props.gap
            ? css`
                  grid-gap: ${SPACING[props.gap]}px;
              `
            : css`
                  grid-column-gap: ${props.columnGap ? SPACING[props.columnGap] : SPACING[200]}px;
                  grid-row-gap: ${props.rowGap ? SPACING[props.rowGap] : SPACING[200]}px;
              `}

    ${(props) =>
        props.responsive &&
        css`
            ${MEDIA_QUERY['medium-only']} {
                grid-template-areas: ${props.tabletTemplateAreas || 'auto'};
                grid-template-columns: ${props.tabletTemplateColumns || 'auto'};
                grid-template-rows: ${props.tabletTemplateRows || 'auto'};
            }
            ${MEDIA_QUERY['up-to-small']} {
                grid-template-areas: ${props.phoneTemplateAreas || 'auto'};
                grid-template-columns: ${props.phoneTemplateColumns || 'auto'};
                grid-template-rows: ${props.phoneTemplateRows || 'auto'};
            }
        `}

    ${(props) =>
        props.divider &&
        css`
            & > div:nth-child(n) {
                border-right: ${props.divider === 'vertical' ? `1px solid ${ColorPalette.COLOR_NIGHT_100}` : 'none'};
                border-bottom: ${props.divider === 'horizontal' ? `1px solid ${ColorPalette.COLOR_NIGHT_100}` : 'none'};
            }
            & > div:last-child {
                border-right: ${props.divider === 'vertical' && 'none'};
                border-bottom: ${props.divider === 'horizontal' && 'none'};
            }
        `}
    ${(props) =>
        (props.printTemplateAreas || props.printTemplateColumns || props.printTemplateRows) &&
        css`
            ${MEDIA_QUERY.print} {
                grid-template-areas: ${props.printTemplateAreas || 'auto'};
                grid-template-columns: ${props.printTemplateColumns || 'auto'};
                grid-template-rows: ${props.printTemplateRows || 'auto'};
            }
        `}
`;

export const GridItem = styled.div<GridItemProps>`
    ${(props) => props.overflow && `overflow: ${props.overflow}`};
    ${MEDIA_QUERY.print} {
        overflow: visible;
    }
    ${(props) => props.area && `grid-area: ${props.area}`};
    ${(props) => props.column && `grid-column: ${props.column}`};
    ${(props) => props.row && `grid-row: ${props.row}`};
    ${(props) =>
        (props.tabletColumnStart || props.tabletRowStart || props.tabletRowEnd) &&
        css`
            ${MEDIA_QUERY['medium-only']} {
                grid-column-start: ${props.tabletColumnStart || 'auto'};
                grid-row-start: ${props.tabletRowStart || 'auto'};
                grid-row-end: ${props.tabletRowEnd || 'auto'};
            }
        `}
    ${(props) => props.minWidth !== undefined && `min-width: ${props.minWidth}`};
`;
